import React, { useEffect, useState } from "react";
import PrivateLayout from "../../layouts/privateLayout";
import { Box, Container } from "@mui/material";
import BasicBreadcrumbs from "../../components/breadcrumb";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { departmentData } from "../../data/departmentData";
import Form from "./form";
import { Link as RouterLink } from "react-router-dom";
import Link from "@mui/material/Link";
import api from "../../helper/baseApi";
import toast from "react-hot-toast";
import { useApiClient } from "../../context/ApiClientContext";
import ErrorAlert from "../../helper/errorAlert";

const Details = () => {
  const { id } = useParams();
  const location = useLocation();
  const [mode, setMode] = useState('view');
  const [isLoading, setLoading] = React.useState(false);
  const [dataList, setDataList] = useState([]);
  const [inputForm, setInputForm] = useState({
    id: "",
    department: ""
  })
  const navigate = useNavigate();
  const { apiUrls: { mobileApiUrl } } = useApiClient();

  useEffect(() => {
    if (location.pathname.includes("view-department")) {
      setMode("view");
      fetchDataAndUpdateList();
    } else {
      setMode("create");
    }
  }, [location.pathname]);


  const fetchDataAndUpdateList = async () => {
    try {
      setLoading(true);

      const apiUrl = `${mobileApiUrl}department/details?departmentId=${id}`;
      const response = await api.get(apiUrl);

      const deparmentDetails = response.data.data;
      
      setDataList(deparmentDetails);
    } catch (error) {
      ErrorAlert(error, navigate);
    }
  };

  return (
    <PrivateLayout>
      <Box sx={{ mx: "40px", mt: 5 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 2,
            mb: 3,
          }}
        >
          <Box display="flex" justifyContent="start" alignItems="center">
            <BasicBreadcrumbs
              first={
                <Link component={RouterLink} to="/department" underline="hover" color="primary.main">
                  Department
                </Link>
              }
              second={mode === "view" ? "View" : mode === "edit" ? "Edit" : "Add"}
            />
            <Box sx={{ display: "flex" }}></Box>
          </Box>
        </Box>
        <Box px={3} sx={{ width: "100%" }}>
          <Form mode={mode} departmentDetails={dataList} onModeChange={setMode} />
          {/* <ValueTagHeaderForm mode={mode} valueTagDetails={valueTagDetails} onModeChange={setMode} /> */}
        </Box>
      </Box>
      {/* </Box> */}
    </PrivateLayout>
  );
};

export default Details;
